export type EmployeeReportTemplate = 'employee-statement' | 'employee-timesheet';
export type RestaurantReportTemplate = EmployeeReportTemplate | 'monthly-timesheet';
export type RestaurantReportChannel = 'print' | 'telegram' | 'viber';

type ReportFields = { allowed: readonly string[]; defaults: readonly string[] };

export const restaurantReportFields: Record<RestaurantReportTemplate, ReportFields> = {
  'employee-statement': {
    allowed: ['position', 'attendance', 'attendance-intervals', 'attendance-hours', 'attendance-coefficients',
      'attendance-notes', 'payroll', 'payroll-breakdown', 'payroll-method', 'payroll-rates',
      'payroll-revenue', 'payroll-bonuses', 'payroll-penalties', 'adjustments'],
    defaults: ['payroll'],
  },
  'employee-timesheet': {
    allowed: ['position', 'attendance', 'attendance-intervals', 'attendance-hours',
      'attendance-coefficients', 'attendance-notes'],
    defaults: ['attendance', 'attendance-intervals', 'attendance-hours'],
  },
  'monthly-timesheet': {
    allowed: ['position', 'department', 'daily-hours', 'weighted-hours', 'interval-count', 'notes'],
    defaults: ['daily-hours'],
  },
};

export const restaurantReportDefaultFields = (
  template: RestaurantReportTemplate, channel: RestaurantReportChannel = 'print',
): readonly string[] => template === 'employee-timesheet' && channel !== 'print'
  ? ['attendance', 'attendance-hours'] : restaurantReportFields[template].defaults;

export const hasRestaurantSalaryFields = (fields: readonly string[]) =>
  fields.some(field => field === 'payroll' || field.startsWith('payroll-') || field === 'adjustments');

export const hasRestaurantAttendanceFields = (fields: readonly string[]) =>
  fields.some(field => field === 'attendance' || field.startsWith('attendance-'));

export const hasRestaurantPayrollSnapshotFields = (fields: readonly string[]) =>
  hasRestaurantSalaryFields(fields) ||
  fields.some(field => field === 'attendance-hours' || field === 'attendance-coefficients');
